import request from '@/libs/request'

// 顶部统计
export function topStatis () {
  return request({
    url: `home/statis`,
    method: 'get'
  })
}

export function goodsStatis () {
  return request({
    url: `home/goodsStatis`,
    method: 'get'
  })
}

export function userStatis () {
  return request({
    url: `home/userStatis`,
    method: 'get'
  })
}
export function orderStatis () {
  return request({
    url: `home/orderStatis`,
    method: 'get'
  })
}
